module.exports = __webpack_public_path__ + "media/images/img_operator-aef1e5c2a53e4df8d517237f158fa44f.png";